<!-- Split layout for client-portal -->
<div *ngIf="isClientPortal(); else standardLogin" class="login-split">
  <!-- Left: branding panel with background image -->
  <div class="brand-panel">
    <div class="brand-overlay" aria-hidden="true"></div>
    <div class="brand-content">
      <img src="assets/hypenation-white-logo.svg" alt="Hypenation" class="brand-logo" width="180" height="40" />
      <h1 class="brand-heading">Your Gateway to Unrivaled Experiences</h1>
      <p class="brand-sub">Buy and Share Tickets with a Vibrant Community of Event Lovers.</p>
    </div>
  </div>

  <!-- Right: form panel -->
  <div class="form-panel">
    <div class="form-wrapper">
      <div class="form-header">
        <h2 class="form-title">Sign In</h2>
        <p class="form-sub">Enter your email to receive a one-time code</p>
      </div>

      <!-- Email step -->
      <form
        *ngIf="step() === 'email'"
        [formGroup]="emailForm"
        (ngSubmit)="onEmailSubmit()"
        class="login-form"
      >
        <div class="field">
          <label for="login-email" class="field-label">Email Address</label>
          <input
            id="login-email"
            nz-input
            nzSize="large"
            formControlName="email"
            type="email"
            autocomplete="email"
            spellcheck="false"
            placeholder="you@example.com"
            class="field-input"
          />
          <span class="field-error" *ngIf="emailForm.get('email')?.dirty && emailForm.get('email')?.hasError('email')">
            Please enter a valid email address
          </span>
        </div>

        <button
          nz-button
          nzType="primary"
          nzSize="large"
          nzBlock
          [nzLoading]="loading()"
          type="submit"
          class="submit-btn"
        >
          Send OTP
        </button>
      </form>

      <!-- OTP step -->
      <form
        *ngIf="step() === 'otp'"
        [formGroup]="otpForm"
        (ngSubmit)="onOtpSubmit()"
        class="login-form"
      >
        <div class="otp-info">
          <p>We sent a code to</p>
          <p class="otp-email">{{ email() }}</p>
        </div>

        <div class="field">
          <label for="login-otp" class="field-label">Verification Code</label>
          <input
            id="login-otp"
            nz-input
            nzSize="large"
            formControlName="otp"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            spellcheck="false"
            placeholder="Enter 6-digit code"
            maxlength="6"
            class="field-input otp-input"
          />
          <span class="field-error" *ngIf="otpForm.get('otp')?.dirty && otpForm.get('otp')?.hasError('minlength')">
            Code must be at least 4 digits
          </span>
        </div>

        <div class="btn-row">
          <button
            nz-button
            nzType="default"
            nzSize="large"
            type="button"
            (click)="goBack()"
            [disabled]="loading()"
            class="back-btn"
          >
            Back
          </button>
          <button
            nz-button
            nzType="primary"
            nzSize="large"
            [nzLoading]="loading()"
            type="submit"
            class="verify-btn"
          >
            Verify
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Standard image-based login for ticketing/hac -->
<ng-template #standardLogin>
  <div
    class="min-h-screen flex items-center justify-center px-4 py-12 relative"
    [style.background-image]="'url(' + bannerImage() + ')'"
    style="background-size: cover; background-position: center; background-repeat: no-repeat;"
  >
    <div class="absolute inset-0 bg-black/60 z-0"></div>
    <div class="relative z-10 w-full max-w-md">
      <nz-card [nzBordered]="false" class="!bg-white/95 backdrop-blur-sm shadow-2xl">
        <div class="text-center mb-6">
          <h2 class="text-2xl font-bold text-gray-900">Login</h2>
          <p class="text-sm text-gray-600 mt-2">
            Enter your email and we'll send you an OTP to authenticate
          </p>
        </div>

        <form
          *ngIf="step() === 'email'"
          [formGroup]="emailForm"
          (ngSubmit)="onEmailSubmit()"
          class="space-y-6"
        >
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Email</nz-form-label>
            <nz-form-control nzErrorTip="Please enter a valid email address" [nzSpan]="24">
              <input
                nz-input
                nzSize="large"
                formControlName="email"
                type="email"
                autocomplete="email"
                spellcheck="false"
                placeholder="Enter your email"
              />
            </nz-form-control>
          </nz-form-item>

          <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="loading()" type="submit">
            Send OTP
          </button>
        </form>

        <form
          *ngIf="step() === 'otp'"
          [formGroup]="otpForm"
          (ngSubmit)="onOtpSubmit()"
          class="space-y-6"
        >
          <div class="text-center mb-4">
            <p class="text-sm text-gray-600">We've sent an OTP to</p>
            <p class="text-sm font-semibold text-gray-900 mt-1">{{ email() }}</p>
          </div>

          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>OTP Code</nz-form-label>
            <nz-form-control nzErrorTip="Please enter the OTP code" [nzSpan]="24">
              <input
                nz-input
                nzSize="large"
                formControlName="otp"
                type="text"
                inputmode="numeric"
                autocomplete="one-time-code"
                spellcheck="false"
                placeholder="Enter OTP code"
                maxlength="6"
              />
            </nz-form-control>
          </nz-form-item>

          <div class="flex gap-3">
            <button nz-button nzType="default" nzSize="large" type="button" (click)="goBack()" [disabled]="loading()" class="flex-1">
              Back
            </button>
            <button nz-button nzType="primary" nzSize="large" [nzLoading]="loading()" type="submit" class="flex-1">
              Verify OTP
            </button>
          </div>
        </form>
      </nz-card>
    </div>
  </div>
</ng-template>
